/* eslint-disable @typescript-eslint/no-misused-promises */
// import EntypoIcon from '@expo/vector-icons/Entypo'
import BaseUIPaymentSubscriptionView from 'xui/modules/subscription/BaseUIPaymentSubscriptionView'
// import { Subscriptions } from 'xui/modules/subscription/Subscriptions'

export default class PaymentSubscriptionView extends BaseUIPaymentSubscriptionView {
  static displayName = 'PaymentSubscriptionView'

  _downloadQrImage = (base64String: string) => {
    const link = document.createElement('a')
    link.href = `data:image/gif;base64,${base64String}`
    link.download = `qr-code-${Date.now()}.png`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
